import { MIN_COUNTED_GAMES } from "./bookScorecard.js";

/** The z for a 95% range. */
const Z95 = 1.96;

/**
 * The Results page's "Which books to trust": each book's moved-right rate
 * (`bookScorecard` rows) with a 95% range, p ± 1.96·sqrt(p(1−p)/n), best
 * first. Books with fewer than MIN_COUNTED_GAMES counted games are left off:
 * one week is not a track record. `tooEarly` is true while every range still
 * crosses 50% -- no book is yet distinguishable from a coin.
 */
export function bookTrust(summary) {
  const rows = (summary && summary.rows ? summary.rows : [])
    .filter((row) => row.rate != null && row.counted >= MIN_COUNTED_GAMES)
    .map((row) => {
      const se = Math.sqrt((row.rate * (1 - row.rate)) / row.counted);
      return {
        bookmaker: row.bookmaker,
        sharp: row.sharp,
        right: row.right,
        counted: row.counted,
        rate: row.rate,
        low: Math.max(0, row.rate - Z95 * se),
        high: Math.min(1, row.rate + Z95 * se),
      };
    })
    .sort((a, b) => b.rate - a.rate || b.counted - a.counted || a.bookmaker.localeCompare(b.bookmaker));
  return {
    games: summary ? summary.games : 0,
    rows,
    tooEarly: rows.length > 0 && rows.every((row) => row.low < 0.5 && row.high > 0.5),
  };
}
